/**
 * Constants for the Booking Configuration feature.
 */

export const DAYS_OF_WEEK = [
  { value: 1, label: 'Mon' },
  { value: 2, label: 'Tue' },
  { value: 3, label: 'Wed' },
  { value: 4, label: 'Thu' },
  { value: 5, label: 'Fri' },
  { value: 6, label: 'Sat' },
  { value: 7, label: 'Sun' }
];

export const BOOKING_TEMPLATE_FIELDS = [
  'confirmation_new_appointment_template_id',
  'reminder_template_id_lead',
  'reminder_template_id_smb',
  'cancellation_notification_template_lead',
  'cancellation_notification_template_smb',
  'reschedule_notification_template_lead',
  'reschedule_notification_template_smb'
] as const;

export const FIELD_LABELS: Record<string, string> = {
  confirmation_new_appointment_template_id: 'New Appointment Confirmation',
  reminder_template_id_lead: 'Lead Reminder',
  reminder_template_id_smb: 'SMB Reminder',
  cancellation_notification_template_lead: 'Lead Cancellation Notification',
  cancellation_notification_template_smb: 'SMB Cancellation Notification',
  reschedule_notification_template_lead: 'Lead Reschedule Notification',
  reschedule_notification_template_smb: 'SMB Reschedule Notification',
};